import React from 'react'
// import data from '../data'
import { AlertEmpty } from '../../../components';
import ListItem from './list-item';

const List = ({ data }) => {
  return (
    <div className="list mb-8 lg:mb-0">
      {
        data && data.length > 0 ? (
          <div className="mobile-fullwidth">
            {data.map((d, index) => (
              <ListItem key={index} data={d} index={index}/>
            ))}
          </div>
        ) : (
          <AlertEmpty />
        )
      }
    </div>
  )
}

export { List }
